import { gql } from '@apollo/client';

import {
  GenerateModeratorSpeechV2Document,
  type GenerateModeratorSpeechV2Mutation,
  type GenerateModeratorSpeechV2MutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation GenerateModeratorSpeechV2(
      $input: GenerateModeratorSpeechV2Input!
    ) {
      generateModeratorSpeechV2(input: $input) {
        audioData
      }
    }
  `;
}

export const GENERATE_MODERATOR_SPEECH_V2 = GenerateModeratorSpeechV2Document;
export type {
  GenerateModeratorSpeechV2Mutation,
  GenerateModeratorSpeechV2MutationVariables,
};
